import React from 'react';
import { useParams } from 'next/navigation';
import { Index } from 'react-instantsearch-hooks';
import {
  productsIndex_NZ,
  productsIndex_AU,
  productsSearchIndex_AU,
  productsSearchIndex_NZ,
  productsQuerySuggestionsIndex_AU,
  productsQuerySuggestionsIndex_NZ,
  contentIndex_AU,
  contentIndex_NZ,
} from 'helpers/constants/algolia';

interface Props {
  type: 'products' | 'query-suggestions' | 'content';
  isSearch?: boolean;
}

export const useLocalizedIndex = ({ type, isSearch }: Props) => {
  const { locale, slug } = useParams();
  const isSearchPage = (slug?.indexOf('search') !== -1) || isSearch;
  const indexes = {
    products: {
      au: isSearchPage ? productsSearchIndex_AU : productsIndex_AU,
      nz: isSearchPage ? productsSearchIndex_NZ : productsIndex_NZ,
    },
    'query-suggestions': {
      au: productsQuerySuggestionsIndex_AU,
      nz: productsQuerySuggestionsIndex_NZ,
    },
    content: {
        au: contentIndex_AU,
        nz: contentIndex_NZ,
      }
  };

  const indexName = indexes[type][locale as 'au' | 'nz'];

  return { indexName };
};

const LocalizedIndex = ({ children, type, isSearch }: React.PropsWithChildren<Props>) => {
  const { indexName } = useLocalizedIndex({ type, isSearch });

  return <Index indexName={indexName}>{children}</Index>;
};

export default LocalizedIndex;
